import { marqueeItems } from "@/mocks/home";

export default function NoticeBar() {
  const loop = [...marqueeItems, ...marqueeItems];
  return (
    <section aria-label="主播最新动态滚动条" className="border-y border-background-200 bg-secondary-100/70">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="flex items-center gap-3 py-3">
          <span className="hidden sm:inline-flex shrink-0 items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 whitespace-nowrap">
            <i className="ri-megaphone-line" />
            最新
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee gap-8">
              {loop.map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="flex items-center gap-2 text-xs md:text-sm text-foreground-700 whitespace-nowrap"
                >
                  <i className="ri-flashlight-line text-accent-600" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}